(function () {
  /* ---------- Live Hulk offers for each card ---------- */
  var H = window.hulkapps || {};
  var API = (H.vd_url || 'https://volumediscount.hulkapps.com') + '/api/v2/shop/get_offer_table';
  var TTL = 10 * 60 * 1000;
  var queue = [], active = 0, MAX = 4;

  function money(c) { return '£' + (c / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function body(el) {
    var pid = el.getAttribute('data-pid');
    var tags = [];
    try { tags = JSON.parse(el.getAttribute('data-tags') || '[]'); } catch (e) {}
    var p = new URLSearchParams();
    p.append('store_id', H.store_id || '');
    p.append('pid', pid);
    p.append('product_variants', el.getAttribute('data-vids') || '');
    p.append('product_collections', el.getAttribute('data-cols') || '');
    tags.forEach(function (t) { p.append('product_tags[' + pid + '][]', t); });
    p.append('ctags', H.customer && H.customer.tags ? H.customer.tags : '');
    p.append('customer_orders_count', '');
    p.append('geo_country', H.geo_country || '');
    p.append('market_country', H.market_country || '');
    return p.toString();
  }

  function cached(pid) {
    try {
      var c = JSON.parse(sessionStorage.getItem('bnpvd:' + pid) || 'null');
      if (c && Date.now() - c.t < TTL) return c;
    } catch (e) {}
    return null;
  }
  function store(pid, offer) {
    try { sessionStorage.setItem('bnpvd:' + pid, JSON.stringify({ t: Date.now(), o: offer })); } catch (e) {}
  }

  function load(el) {
    if (!el.classList.contains('bnp-pack--pending') || el.getAttribute('data-bnp-q')) return;
    el.setAttribute('data-bnp-q', '1');
    var c = cached(el.getAttribute('data-pid'));
    if (c) { apply(el, c.o); return; }
    queue.push(el); pump();
  }
  function pump() {
    while (active < MAX && queue.length) {
      (function (el) {
        active++;
        fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }, body: body(el) })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            var o = d && d.eligible_offer ? d.eligible_offer : null;
            var slim = o ? { levels: o.offer_levels, dt: o.discount_type, title: o.offer_title || o.offer_name || '' } : null;
            store(el.getAttribute('data-pid'), slim);
            apply(el, slim);
          })
          .catch(function () { apply(el, null); })
          .then(function () { active--; pump(); });
      })(queue.shift());
    }
  }

  /* Turn a Hulk offer into pack rows. Supports the per-item offer types used on this store:
     "% Off" (percentage off each), "fix_price" (set price each) and fixed "Off" (amount off each). */
  function tiers(offer, price) {
    if (!offer || offer.dt !== 'each_qty') return [];
    var levels = [];
    try { levels = JSON.parse(offer.levels || '[]'); } catch (e) { return []; }
    var out = [];
    levels.forEach(function (l) {
      var q = parseInt(l[0], 10), v = parseFloat(l[1]), type = String(l[2] || '');
      if (!(q > 1) || isNaN(v)) return;
      var total, off = null;
      if (type.indexOf('%') > -1) {
        total = Math.round(price * q * (100 - v) / 100 + 1e-9);
        off = v;
      } else if (type === 'fix_price') {
        total = Math.round(v * 100) * q;
      } else if (/off/i.test(type)) {
        total = (price - Math.round(v * 100)) * q;
      } else { return; }
      if (!(total > 0) || total >= price * q) return;
      out.push({ q: q, total: total, each: Math.round(total / q), off: off });
    });
    out.sort(function (a, b) { return a.q - b.q; });
    return out;
  }

  function apply(el, offer) {
    el.classList.remove('bnp-pack--pending');
    var price = parseInt(el.getAttribute('data-price'), 10);
    var rows = tiers(offer, price);
    var tog = el.querySelector('.bnp-pack__toggle');
    if (!rows.length) { el.classList.add('bnp-pack--none'); tog.disabled = true; return; }
    var name = 'bnp-pack-' + el.getAttribute('data-pid') + '-' + Math.random().toString(36).slice(2, 7);
    var last = rows[rows.length - 1];
    var html = row(name, 1, price, price, null, false, true);
    rows.forEach(function (r) { html += row(name, r.q, r.total, r.each, r.off, rows.length > 1 && r === last, false); });
    el.querySelector('.bnp-pack__list').innerHTML = html;
    var note = el.querySelector('.bnp-pack__note');
    if (offer.title) { note.textContent = offer.title; } else { note.hidden = true; }
    tog.disabled = false;
    el.classList.add('bnp-pack--ready');
    var save = last.off != null ? last.off : Math.floor((1 - last.total / (price * last.q)) * 100);
    var card = el.closest('.bnp-card');
    var pill = card && card.querySelector('.bnp-offer-pill');
    if (pill && save > 0) { pill.textContent = (rows.length > 1 ? 'Save up to ' : 'Save ') + save + '%'; pill.hidden = false; }
  }

  function row(name, q, total, each, off, best, checked) {
    var tag = off ? ' <span class="bnp-pack__save">-' + esc(off) + '%</span>' : '';
    if (best) tag += ' <span class="bnp-pack__best">BEST VALUE</span>';
    return '<label class="bnp-pack__opt"><input type="radio" name="' + name + '" value="' + q + '" data-total="' + money(total) + '" data-each="' + money(each) + '"' + (checked ? ' checked' : '') + '>' +
      '<span class="bnp-pack__name">' + q + ' Pack' + tag + '</span>' +
      '<span class="bnp-pack__price">' + money(total) + '</span>' +
      '<span class="bnp-pack__each">' + money(each) + '/unit</span>' +
      '<span class="bnp-pack__tick" aria-hidden="true"></span></label>';
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } });
  }, { rootMargin: '400px 0px' }) : null;

  function init() {
    var els = document.querySelectorAll('.bnp-pack--pending:not([data-bnp-seen])');
    if (!els.length) return;
    els.forEach(function (el, i) {
      el.setAttribute('data-bnp-seen', '1');
      /* No observer, or the page is opened in a background tab: load the first row straight away */
      if (!io || (document.visibilityState === 'hidden' && i < 8)) { load(el); return; }
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Re-run when filters or sort swap the product grid */
  var section = document.querySelector('.main-collection-product-grid-section');
  if (section && 'MutationObserver' in window) new MutationObserver(init).observe(section, { childList: true, subtree: true });

  /* ---------- Dropdown / bottom sheet ---------- */
  var open = null;
  var mq = window.matchMedia('(max-width: 749px)');

  function close(pack, focusToggle) {
    if (!pack) return;
    var panel = pack.querySelector('.bnp-pack__panel');
    var tog = pack.querySelector('.bnp-pack__toggle');
    panel.hidden = true;
    tog.setAttribute('aria-expanded', 'false');
    pack.classList.remove('is-open');
    document.documentElement.classList.remove('bnp-sheet-open');
    if (focusToggle) tog.focus();
    if (open === pack) open = null;
  }
  function show(pack) {
    if (open && open !== pack) close(open);
    var panel = pack.querySelector('.bnp-pack__panel');
    var tog = pack.querySelector('.bnp-pack__toggle');
    panel.hidden = false;
    tog.setAttribute('aria-expanded', 'true');
    pack.classList.add('is-open');
    if (mq.matches) document.documentElement.classList.add('bnp-sheet-open');
    var checked = panel.querySelector('input:checked') || panel.querySelector('input');
    if (checked) checked.focus();
    open = pack;
  }

  document.addEventListener('click', function (e) {
    var tog = e.target.closest('.bnp-pack__toggle');
    if (tog) {
      if (tog.disabled) return;
      var pack = tog.closest('.bnp-pack');
      if (pack.classList.contains('is-open')) close(pack, true); else show(pack);
      return;
    }
    if (e.target.closest('.bnp-pack__close')) { close(open, true); return; }
    if (open && !e.target.closest('.bnp-pack__panel')) close(open);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) close(open, true); });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.bnp-pack__opt input')) return;
    var pack = input.closest('.bnp-pack');
    var form = input.closest('form');
    var qty = parseInt(input.value, 10) || 1;
    form.querySelector('.bnp-qty').value = qty;
    pack.querySelector('.bnp-pack__current').textContent = qty + ' Pack';
    pack.querySelector('.bnp-bar__total').textContent = input.getAttribute('data-total');
    pack.querySelector('.bnp-bar__unit').textContent = '(' + input.getAttribute('data-each') + '/unit)';
    var label = form.querySelector('.bnp-btn-label');
    if (label) label.textContent = qty === 1 ? 'Add to cart' : 'Add ' + qty + ' to cart';
    setTimeout(function () { close(pack, true); }, 150);
  });
})();
